import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryEffectivePriceLcl(data) {
  return request({
    url: URL.price.queryEffectivePriceLcl,
    method: 'post',
    data
  })
}
// 拼箱运价输入-待审核列表
export function queryPendingPriceLcl(data) {
  return request({
    url: URL.price.queryPendingPriceLcl,
    method: 'post',
    data
  })
}

export function queryByPriceNo(params) {
  return request({
    url: URL.price.queryByPriceNoLcl,
    method: 'get',
    params
  })
}

// 费用tab-运价表查询
export function queryOpenPriceLcls(data) {
  return request({
    url: URL.price.queryOpenPriceLcls,
    method: 'post',
    data
  })
}
// 拼箱运价输入-保存运价信息
export function savePriceLcl(data) {
  return request({
    url: URL.price.savePriceLcl,
    method: 'post',
    data
  })
}
// 拼箱运价输入-修改移除运价信息
export function inactivePriceLcls(data) {
  return request({
    url: URL.price.inactivePriceLcls,
    method: 'post',
    data
  })
}
// 拼箱运价输入-删除运价信息
export function deletePriceLcls(data) {
  return request({
    url: URL.price.deletePriceLcls,
    method: 'post',
    data
  })
}
// 拼箱运价输入-修改运价状态
export function updatePriceStateOfPriceLcls(data, params) {
  return request({
    url: URL.price.updatePriceStateOfPriceLcls,
    method: 'post',
    data,
    params
  })
}
// 拼箱运价输入-运价审核
export function approvePriceLcls(data) {
  return request({
    url: URL.price.approvePriceLcls,
    method: 'post',
    data
  })
}
// 根据运价UUID查询
export function queryPriceLclByKey(params) {
  return request({
    url: URL.price.queryPriceLclByKey,
    method: 'get',
    params: params
  })
}
